export default __webpack_public_path__ + "static/media/distance.640354e6.png";